var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import Vuex from 'vuex';
import * as moment from 'moment';
import userModule from './modules/user';
import edarModule from './modules/edar';
import deploymentModule from './modules/deployment';
Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        user: userModule,
        edar: edarModule,
        deployment: deploymentModule,
    },
    state: {
        'loaded': null,
        'debug': false,
    },
    mutations: {
        _markLoaded(state, payload) {
            state.loaded = moment();
        },
        setDebug(state, payload) {
            state.debug = payload;
        },
    },
    actions: {
        //This is the first thing that happens when a page is loaded for the first time ever
        doInitialLoad: (context, payload = []) => new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                let promises = [];
                promises.push(store.dispatch('user/getUser'));
                if (payload.includes('edar')) {
                    promises.push(context.dispatch('edar/getEdars'));
                }
                if (payload.includes('deployment')) {
                    promises.push(context.dispatch('deployment/getDeployments'));
                }
                for (let promise of promises) {
                    yield promise;
                }
            }
            catch (error) {
                // console.log(error);
            }
            context.commit('_markLoaded');
            resolve();
        })),
    },
});
export default store;
